import * as React from "react";
import { useMemo, useState } from "react";
import { useFormikContext } from "formik";
import { Spinner } from "components/common";
import { RowContainer, ColContainer } from "components/lookup-tables/layout-componets";
import useScopePermissions from "hooks/useScopePermissions";
import { useFetchDataAdapter, useFetchAllDataAdapters } from "components/lookup-tables/hooks/useLookupTablesAPI";
import DataAdapterPicker from "components/lookup-tables/adapter-form/AdapterPicker";
import DataAdapterFormView from "components/lookup-tables/adapter-form/AdapterFormView";
import AdapterShow from "components/lookup-tables/adapter-view/adapter-show";
function DataAdapterFormStep() {
  const { values, setFieldValue } = useFormikContext();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(values);
  const { allDataAdapters, loadingAllDataAdapters } = useFetchAllDataAdapters();
  const { dataAdapter, loadingDataAdapter } = useFetchDataAdapter(values.data_adapter_id);
  const [showForm, setShowForm] = useState(false);
  const showAdapter = useMemo(() => !!dataAdapter, [dataAdapter]);
  const canModify = useMemo(
    () => !values.id || !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable),
    [values.id, loadingScopePermissions, scopePermissions == null ? void 0 : scopePermissions.is_mutable]
  );
  const onSaved = (newDataAdapter) => {
    setFieldValue("data_adapter_id", newDataAdapter.id);
    setShowForm(false);
  };
  const onCancel = () => {
    setFieldValue("data_adapter_id", "");
    setShowForm(false);
  };
  const onCreateClick = () => {
    onCancel();
    setTimeout(() => setShowForm(true), 100);
  };
  return /* @__PURE__ */ React.createElement(ColContainer, { $gap: "lg", $align: "center" }, loadingAllDataAdapters ? /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading data adapters..." })) : /* @__PURE__ */ React.createElement(React.Fragment, null, canModify && !showForm && /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(DataAdapterPicker, { onCreateClick, dataAdapters: allDataAdapters })), showAdapter && !loadingDataAdapter && /* @__PURE__ */ React.createElement(AdapterShow, { dataAdapter }), showForm && !showAdapter && /* @__PURE__ */ React.createElement(DataAdapterFormView, { onCancel, saved: onSaved, isStep: true })));
}
export default DataAdapterFormStep;
